import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthService,
  BalanceQuery,
  config,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  NotificationCenterQuery,
} from '@fgb/core';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Populations } from 'src/app/shared/utilities/populations';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit, OnDestroy {
  @ViewChild('greedyNav', { static: false }) navBar: ElementRef<HTMLElement>;
  @ViewChild('greedyDropdown', { static: true }) moreDropdown: ElementRef<HTMLElement>;
  @ViewChild('moreBtn', { static: false }) moreBtn: ElementRef<HTMLElement>;

  breakPoints: number[] = [];
  populations = Populations;
  productcode = ProductCode;

  memberDetails$: Observable<MemberDetails | undefined>;
  combinedCard$: Observable<number | undefined>;
  loyaltyPointsCard$: Observable<number | undefined>;
  card$: Observable<MemberCard | undefined>;
  unseenNotificationCount$: Observable<number>;
  isCollapsed = false;
  isHelpOpen = true;
  
  currentLanguage: string = '';

  private _destroyed$ = new Subject<void>();

  constructor(
    public router: Router,
    public memberQuery: MemberQuery,
    private authService: AuthService,
    private balanceQuery: BalanceQuery,

    private memberCardQuery: MemberCardQuery,
    private notificationQuery: NotificationCenterQuery
  ) {}

  ngOnInit() {
    this.isCollapsed=true;
    this.loyaltyPointsCard$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.combinedCard$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.card$ = this.memberCardQuery.selectObservedMemberCard();
    this.unseenNotificationCount$ = this.notificationQuery.unseenNotificationsCount$;
    this.initLcid();
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  initLcid() {
    this.memberQuery.userContext$.pipe(takeUntil(this._destroyed$)).subscribe((user) => {
      if (user && user.lcid) {
        if (user.lcid === '2057') {
          this.currentLanguage = 'EN';
        } else if (user.lcid === '3084') {
          this.currentLanguage = 'FR';
        } else if (user.lcid === '1037') {
          this.currentLanguage = 'HE';
        } else if (user.lcid === '1033') {
          this.currentLanguage = 'US';
        }
      }
    });
  }

  logout() {
    firstValueFrom(this.authService.logout().pipe(tap(() => this.router.navigate(['/login']))));
  }
}
